window.addEventListener("load", function () {
    const date = new Date();
    var dateExpires = date.setDate(date.getDate() + 1);

    function setCookie(cname, cvalue, exdays) {
        const d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        let expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }

    function getCookie(cname) {
        let name = cname + "=";
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca = decodedCookie.split(";");
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == " ") {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

    function checkPopupShown() {
        return getCookie("popup_shown");
    }

    $(document).ready(function () {
        var country = $('[name="country_code"]').val().toLowerCase();
        console.log(country)
        // Check if the popup has already been shown
        // if (!checkPopupShown() && shouldDisplayPopup() && country === 'us') {
        //     console.log(checkPopupShown());
        //     setCookie('popup_shown', 'true', 1); // Set cookie to indicate popup has been shown
        //     $('.location-popup, .location-popup__overlay').show();
        // }
    });

    $(document).on("click", "[data-shop-selector-redirect]", function () {
        $(".location-popup, .location-popup__overlay").show();
        // var href = $(this).attr("data-shop-selector-redirect");
        // var usLink = $(this).attr("data-shop-us-redirect");
        // var ukLink = $(this).attr("data-shop-uk-redirect");
        // var country = $('[name="country_code"]').val().toLowerCase();

        // setCookie('shopredirect_country', country, 1);
        // setCookie("shopredirect", href, 1);
        // setCookie("shopredirect_us", usLink, 1);
        // setCookie("shopredirect_uk", ukLink, 1);
        // setCookie("shopredirect_click", "yes", 1);
        console.log("shop now popup clicked")
    }); 
});
